import useScrollPosition from '@react-hook/window-scroll'
import { Navbar } from 'react-bootstrap';

export default function NavbarHook(props) {
  // Initialize the hook
  const scrollY = useScrollPosition(0);

  // use setRef to indicate the element you want to monitor
  return (
    <Navbar className={'fixed-top ' + (scrollY > 40 ? 'navbar-sticky' : '')}>{props.children}</Navbar>
  );
}